import VueRouter from 'vue-router';
import store from './store';
import Vue from 'vue';

const trans = Vue.prototype.trans;

const title = process.env.MIX_TITLE;

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/members',
      name: 'members',
      // component: Members,
      component: () => import('#js_site/views/pages/Members'),
      meta: {
        layout: 'AppLayout',
        title: title + ' | ' + trans.get('pages:members.title'),
        profile: true,
        showCoins: true,
      }
    }, {
      path: '/match-game',
      name: 'match_game',
      // component: MatchGame,
      component: () => import('#js_site/views/pages/MatchGame'),
      meta: {
        layout: 'AppLayout',
        title: title + ' | ' + trans.get('pages:match_game.title'),
        profile: true,
        showCoins: true,
      }
    }, {
      path: '/chat',
      name: 'chat',
      // component: Chat,
      component: () => import('#js_site/views/pages/Chat'),
      meta: {
        layout: 'ChatLayout',
        title: title + ' | ' + trans.get('pages:chat.title'),
      }
    }, {
      path: '/profile',
      name: 'user',
      // component: User,
      component: () => import('#js_site/views/pages/User'),
      meta: {
        layout: 'AppLayout',
        title: title + ' | ' + trans.get('profile:index.title'),
        profile: false,
      }
    }, {
      path: '/profile/edit',
      name: 'user.edit',
      // component: UserEdit,
      component: () => import('#js_site/views/pages/UserEdit'),
      meta: {
        layout: 'AppLayout',
        title: title + ' | ' + trans.get('profile:edit.title'),
        profile: false,
      }
    }, {
      path: '/profile/:id(\\d+)',
      name: 'profile',
      // component: Profile,
      component: () => import('#js_site/views/pages/Profile'),
      meta: {
        layout: 'AppLayout',
        title: title + ' | ' + trans.get('profile:show.title'),
        profile: true,
        showCoins: true,
      }
    }, {
      path: '/more-settings/blocked-members',
      name: 'blocked_members',
      // component: BlockedMembers,
      component: () => import('#js_site/views/pages/MoreSettings/BlockedMembers'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:blocked_member.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/payment/last-chance/:unit',
      name: 'last_chance',
      // component: LastChance,
      component: () => import('#js_site/views/pages/MoreSettings/LastChance'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      }
    }, {
      path: '/more-settings/payment/success',
      name: 'payment-success',
      component: () => import('#js_site/views/pages/MoreSettings/PaymentSuccess'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      }
    }, {
      path: '/more-settings/payment/abort',
      name: 'payment-abort',
      component: () => import('#js_site/views/pages/MoreSettings/PaymentAbort'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      }
    }, {
      path: '/more-settings/payment/:unit',
      name: 'payment',
      // component: Payment,
      component: () => import('#js_site/views/pages/MoreSettings/Payment'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      },
      beforeEnter(to, from, next) {
        store.commit('shop/setSelectedPackage', null);

        if (to.hash !== '#b') {
          store.commit('shop/setVoucher', null);
        }

        next();
        return true;
      },
    }, {
      path: '/more-settings/payment/:unit/:packageId',
      name: 'payment-method',
      component: () => import('#js_site/views/pages/MoreSettings/Payment'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      },
    }, {
      path: '/more-settings/payment',
      name: 'payment-coins',
      // component: Payment,
      component: () => import('#js_site/views/pages/MoreSettings/Payment'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title,
        profile: false,
      }
    }, {
      path: '/more-settings/quiz',
      name: 'quiz',
      // component: Quiz,
      component: () => import('#js_site/views/pages/MoreSettings/Quiz'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:quiz.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/password',
      name: 'password',
      // component: Password,
      component: () => import('#js_site/views/pages/MoreSettings/Password'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:password.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/notifications',
      name: 'notifications',
      // component: Notifications,
      component: () => import('#js_site/views/pages/MoreSettings/Notifications'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:notification.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/faq',
      name: 'faq',
      // component: Faq,
      component: () => import('#js_site/views/pages/MoreSettings/Faq'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('pages:faq.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/payment-history',
      name: 'payment-history',
      // component: PaymentHistory,
      component: () => import('#js_site/views/pages/MoreSettings/PaymentHistory'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:payment_history.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/reports',
      name: 'tickets',
      // component: Tickets,
      component: () => import('#js_site/views/pages/MoreSettings/Tickets'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:support.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/terms',
      name: 'terms',
      // component: Terms,
      component: () => import('#js_site/views/pages/MoreSettings/Terms'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:terms.title'),
        profile: false,
      }
    }, {
      path: '/more-settings/reports/:id',
      name: 'tickets.show',
      // component: Ticket,
      component: () => import('#js_site/views/pages/MoreSettings/Ticket'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:support.title'),
        profile: false,
      }
    }, {
      path: '/more-settings',
      name: 'more-settings',
      // component: Payment,
      component: () => import('#js_site/views/pages/MoreSettings/Payment'),
      meta: {
        layout: 'MoreSettingsLayout',
        title: title + ' | ' + trans.get('ms:support.title'),
        profile: false,
      }
    }, {
      path: '/restore-account/:hash',
      name: 'restore-account',
      component: () => import('#js_site/views/pages/RestoreAccount.vue'),
      meta: {
        layout: 'HomeLayout',
        title: title + ' | ' + trans.get('pages:restore_account.title'),
        profile: false,
      }
    },
  ],
});

router.afterEach((to, from) => {
  if (to.meta.title) {
    Vue.nextTick(() => {
      document.title = to.meta.title;
    });
  }
});

router.afterEach((to, from) => {
  store.commit('router/setPrevRoute', { path: from.path, name: from.name });
});

router.afterEach((to, from) => {
  store.dispatch('analytics/fbqTrack', { event: 'PageView', p: { content_name: to.path } });
  // store.dispatch('analytics/appsflyer', { eventType: 'EVENT', eventName: 'PageView', eventValue: { path: to.path }});
});

export default router;
